import React, { forwardRef, MouseEvent } from 'react'
import {
  Radio,
  RadioProps,
  TextField,
  FormControlLabel as MFormControlLabel,
  InputAdornment,
  IconButton,
  Box,
  TextFieldProps,
  formControlLabelClasses,
  formControlClasses,
  inputBaseClasses,
} from '@mui/material'
import Close from '@mui/icons-material/Close'
import { styled } from '@mui/material/styles'

const FormControlLabel = styled(MFormControlLabel)(() => ({
  [`.${formControlLabelClasses.root}`]: {
    display: 'block',
    marginRight: 0,
  },
  [`.${formControlClasses.root}`]: {
    verticalAlign: 'middle',
    width: 'calc(100% - 42px)',
  },
  [`.${inputBaseClasses.root}::before, .${inputBaseClasses.root}::after`]: {
    display: 'none',
  },
}))

interface RadioTextFieldProps {
  onClear: (event: MouseEvent) => void
}

type RadioTextFieldType = RadioProps & {
  textFieldProps: TextFieldProps
} & RadioTextFieldProps

export const RadioTextField: React.ForwardRefExoticComponent<
  React.PropsWithoutRef<RadioTextFieldType> & React.RefAttributes<unknown>
> = forwardRef((props, ref) => {
  const { onClear, textFieldProps, ...radioProps } = props

  const { slotProps } = textFieldProps

  return (
    <Box>
      <FormControlLabel
        sx={{ display: 'block', marginRight: 0 }}
        control={<Radio color="secondary" {...radioProps} ref={ref as any} />}
        label={
          <TextField
            variant="standard"
            {...textFieldProps}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton edge="end" size="small" onClick={onClear}>
                      <Close />
                    </IconButton>
                  </InputAdornment>
                ),
              },
              ...slotProps,
            }}
          />
        }
      />
    </Box>
  )
})
